// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#basket-empty div[data-v-752c3946]{margin-top:22vh;margin-bottom:22vh}#basket-empty svg[data-v-752c3946]{color:#f0f0f0;width:50%;height:30%}#basket-empty h2[data-v-752c3946]{color:#003c71}#order-extra-info[data-v-752c3946]{background-color:#f0f0f0;border-top:1px solid #dcdcdc;border-bottom:1px solid #dcdcdc}#bundle-save[data-v-752c3946],.bg-warning-light[data-v-752c3946]{background-color:#ffe9a4}.disable-all[data-v-752c3946]{pointer-events:none}", ""]);
// Exports
module.exports = exports;
